import {QTableColumn} from 'pansx-utils';
import {TimeAssistantCollaborator} from "@/entity/TimeAssistantCollaborator";

export class TimeAssistant {
    public id?: number;
    public startDate = '';
    public finishDate = '';
    public stopDate = '';
    public programme = '';
    public isFinish?: boolean;
    public username = '';
    public timeAssistantComeFrom = '';
    public timeAssistantCollaborators?: TimeAssistantCollaborator;
    public isSelect?: boolean;

    public static of(o: unknown): TimeAssistant {
        return Object.assign(new TimeAssistant(), o);
    }

    public static getColumns(): QTableColumn[] {
        return [
            {name: 'id', field: 'id', label: '序号'},
            {name: 'userId', field: 'userId', label: '用户id'},
            {name: 'startDate', field: 'startDate', label: '开始日期'},
            {name: 'stopDate', field: 'stopDate', label: '停止日期'},
            {name: 'programme', field: 'programme', label: '程序'},
        ];
    }

    public getColumnLabel(field: string) {
        const columns = TimeAssistant.getColumns();
        const find: QTableColumn | undefined = columns.find(
            (value) => value.field === field
        );
        if (typeof find !== 'undefined') {
            return find.label;
        }
        return '';
    }
}
